import { frontendURL } from 'dashboard/helper/URLHelper';
import WhatsappCallDashboard from './Dashboard.vue';
import WhatsappCallConfiguracao from './Configuracao.vue';

// v109 (WhatsApp Call — Fase 4): rotas do menu. Visibilidade decidida pelo
// Controle de Acesso (keys 'WhatsappCall Dashboard'/'WhatsappCall Config' —
// nascem bloqueadas p/ não-admins via backfill).
const TODAS_ROLES = [
  'administrator',
  'supervisor',
  'agent',
  'operacional',
  'qualidade',
  'ouvidoria',
  'juridico',
  'custom_role',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/whatsapp-call'),
    name: 'whatsapp_call_dashboard',
    component: WhatsappCallDashboard,
    meta: { permissions: TODAS_ROLES },
  },
  {
    path: frontendURL('accounts/:accountId/whatsapp-call/configuracao'),
    name: 'whatsapp_call_config',
    component: WhatsappCallConfiguracao,
    meta: { permissions: TODAS_ROLES },
  },
];

export default { routes };
